import cn from "classnames";

export function FieldErrorMessage({
  id,
  className,
  testId,
  children,
}: FieldErrorMessageProps) {
  return (
    <p
      id={id}
      role="alert"
      className={cn("text-error body-4 mt-1", className)}
      data-testid={testId}>
      <span className="font-semibold">Error:</span> {children}
    </p>
  );
}

export type FieldErrorMessageProps = {
  id?: string;
  className?: string;
  testId?: string;
  children: React.ReactNode;
};
